'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _guessCountryFromDialCode = require('./guessCountryFromDialCode');

var _guessCountryFromDialCode2 = _interopRequireDefault(_guessCountryFromDialCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value) {
  var numberFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var numberText = value;
  var pattern = numberFormat;
  if (!pattern) {
    numberText = value.replace(/\D/g, '');
    var country = value[0] === '+' && (0, _guessCountryFromDialCode2.default)(numberText);
    pattern = country && country.format;
  }

  if (!pattern) {
    return value;
  }

  // for all strings with length less than 3, just return it
  if (numberText && numberText.length < 2 || !pattern) {
    return '+' + numberText.replace(/\D/g, '');
  }

  var formattedObject = pattern.split('').reduce(function (acc, character) {
    if (acc.remainingText.length === 0) {
      return acc;
    }

    if (character !== '.') {
      return {
        formattedText: acc.formattedText + character,
        remainingText: acc.remainingText
      };
    }

    return {
      formattedText: acc.formattedText + acc.remainingText[0],
      remainingText: acc.remainingText.slice(1)
    };
  }, { formattedText: '', remainingText: numberText });

  return formattedObject.formattedText + formattedObject.remainingText;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/utils/formatPhoneNumber.js
// module id = 344
// module chunks = 0